export const valores = [
  {
    label: "De",
    valor: "R$ 169,90",
    unidade: "mês por usuário",
    riscado: true,
  },
  {
    label: "Por apenas",
    valor: "R$ 119,90",
    unidade: "mês por usuário",
    riscado: false,
  }
]